import {
  COMMISSIONS_GET_RANGE_COMMISSION_MONTH_BEGIN,
  COMMISSIONS_GET_RANGE_COMMISSION_MONTH_SUCCESS,
  COMMISSIONS_GET_RANGE_COMMISSION_MONTH_FAILURE
} from '../constants'

export function reducer(state, action) {
  switch (action.type) {
    case COMMISSIONS_GET_RANGE_COMMISSION_MONTH_BEGIN:
      return {
        ...state,
        getRangeCommissionMonthPending: true
      }
    case COMMISSIONS_GET_RANGE_COMMISSION_MONTH_SUCCESS:
      return {
        ...state,
        getRangeCommissionMonthPending: false,
        getRangeCommissionMonthSuccess: true,
        editCommissionMonthRange: action.data,
        getNewCommissionMonthError: null
      }
    case COMMISSIONS_GET_RANGE_COMMISSION_MONTH_FAILURE:
      return {
        ...state,
        getRangeCommissionMonthPending: false,
        getRangeCommissionMonthError: action.data
      }
    default:
      return state
  }
}
